import { DEMO_IDS } from "./schema";
import { getSnapshot, replaceCollections } from "./engine";

const PURGE_FLAG = "dh_demo_content_cleared_v1";

const DEMO_RECORD_IDS = new Set([
  DEMO_IDS.broker,
  DEMO_IDS.agent,
  DEMO_IDS.agent2,
  DEMO_IDS.buyer,
  DEMO_IDS.seller,
  DEMO_IDS.brokerBuyer,
  DEMO_IDS.txBroker,
  DEMO_IDS.threadBroker,
  DEMO_IDS.txBuyer,
  DEMO_IDS.txSeller,
  DEMO_IDS.threadBuyer,
  DEMO_IDS.threadSeller,
  "msg-1",
  "msg-seller-1",
  "msg-broker-own-1",
  "prospect-jordan",
  "pr-jordan",
  "tx-prospect-jordan",
  "thread-prospect-jordan",
  "audit-demo-thread-buyer",
  "audit-demo-msg-1",
  "audit-demo-thread-seller",
  "audit-demo-msg-seller-1",
]);

function filterDemo(list) {
  return (list || []).filter((row) => !row?.id || !DEMO_RECORD_IDS.has(row.id));
}

function purgeLocalList(key, dropIds) {
  try {
    const rows = JSON.parse(localStorage.getItem(key) || "[]");
    if (!Array.isArray(rows) || !rows.length) return;
    const next = rows.filter((row) => !dropIds.has(row.id));
    if (next.length !== rows.length) localStorage.setItem(key, JSON.stringify(next));
  } catch {
    /* ignore */
  }
}

function purgeDemoCredentials() {
  try {
    const map = JSON.parse(localStorage.getItem("dh_j_credentials") || "{}");
    let changed = false;
    [
      DEMO_IDS.broker,
      DEMO_IDS.agent,
      DEMO_IDS.agent2,
      DEMO_IDS.seller,
      DEMO_IDS.buyer,
      DEMO_IDS.brokerBuyer,
    ].forEach((id) => {
      if (map[id]) {
        delete map[id];
        changed = true;
      }
    });
    if (changed) localStorage.setItem("dh_j_credentials", JSON.stringify(map));
  } catch {
    /* ignore */
  }
}

export function seedJourneyDemo() {
  const { collections } = getSnapshot();
  collections.users = filterDemo(collections.users);
  collections.transactions = filterDemo(collections.transactions);
  collections.message_threads = filterDemo(collections.message_threads);
  collections.messages = (collections.messages || []).filter(
    (row) => !DEMO_RECORD_IDS.has(row.id) && !DEMO_RECORD_IDS.has(row.thread_id)
  );
  collections.audit_logs = (collections.audit_logs || []).filter(
    (row) => row.action_type !== "seed.demo" && !DEMO_RECORD_IDS.has(row.id)
  );
  replaceCollections(collections);

  if (typeof localStorage === "undefined") return;
  if (localStorage.getItem(PURGE_FLAG) === "1") return;

  purgeLocalList("dh_buyers", DEMO_RECORD_IDS);
  purgeLocalList("dh_agents", DEMO_RECORD_IDS);
  purgeLocalList("dh_events", new Set(["evt-1", "evt-broker-1"]));
  purgeLocalList("dh_prospects_rows", DEMO_RECORD_IDS);
  purgeLocalList("dh_prospects_timeline", new Set(["pr-t1", "pr-t2"]));
  purgeDemoCredentials();
  localStorage.setItem(PURGE_FLAG, "1");
}
